/**
 * O índice dos formulários da implantação — a lista de trilhas da tela 4.
 *
 * Quais trilhas existem não é escolha desta tela: elas são derivadas dos módulos contratados, no
 * servidor. É o que sustenta a promessa do painel — "você só responde o kickoff dos módulos
 * contratados, as outras trilhas nem aparecem" — e o que impede a lista de oferecer o formulário
 * de um módulo que ninguém comprou.
 *
 * A trilha de infraestrutura é governada por `infra:*` (spec §4): quem tem só `kickoff:ver` não
 * a recebe na resposta. Filtrar no servidor é mais honesto do que listar e negar ao abrir.
 */

import { Link } from "react-router";
import { Aviso, Cartao } from "../componentes/ui";
import { CartaoDaTrilha } from "../componentes/kickoff";
import { AvisoDeSucessoDaChegada } from "../componentes/avisos/AvisoDeSucessoDaChegada";
import { useTitulo } from "../nucleo/titulo";
import { useTrilhas } from "../nucleo/kickoff";

export function FormulariosDaImplantacao() {
  useTitulo("Formulários");
  const consulta = useTrilhas();

  return (
    <>
      <AvisoDeSucessoDaChegada />
      <h1 className="titulo-pagina">Formulários da sua implantação</h1>
      <p className="lead">
        Um formulário por módulo contratado, mais o cadastro base. Cada resposta é salva sozinha
        enquanto você digita — dá para parar no meio, fechar e voltar depois. Nada é enviado à
        equipe até você clicar em enviar.
      </p>

      {consulta.isPending ? (
        <p className="lead" role="status">
          Carregando os seus formulários…
        </p>
      ) : consulta.isError ? (
        <Aviso tom="erro" data-testid="falha-das-trilhas">
          Não foi possível carregar os formulários agora. Atualize a página em alguns instantes;
          se continuar, fale com o consultor responsável.
        </Aviso>
      ) : !consulta.data ? (
        <SemImplantacao />
      ) : consulta.data.trilhas.length === 0 ? (
        <SemTrilhas />
      ) : (
        <>
          <p className="lead" data-testid="resumo-das-trilhas">
            <b>
              {consulta.data.enviadas} de {consulta.data.total}
            </b>{" "}
            {consulta.data.total === 1 ? "formulário enviado" : "formulários enviados"}.
          </p>
          <div className="grade-de-trilhas" data-testid="trilhas">
            {consulta.data.trilhas.map((trilha) => (
              <CartaoDaTrilha key={trilha.chave} trilha={trilha} />
            ))}
          </div>
        </>
      )}

      <p className="nota-rodape mt-5">
        <Link to="/app">Voltar para o acompanhamento da implantação</Link>
      </p>
    </>
  );
}

function SemImplantacao() {
  return (
    <Cartao titulo="Ainda não há uma implantação aberta">
      <Aviso tom="marca" data-testid="sem-implantacao">
        Assim que o time comercial registrar o contrato, os formulários dos módulos contratados
        aparecem aqui. Nada precisa ser feito por você agora.
      </Aviso>
    </Cartao>
  );
}

function SemTrilhas() {
  return (
    <Cartao titulo="Nenhum formulário liberado para você">
      <Aviso tom="atencao" data-testid="sem-trilhas">
        A sua implantação existe, mas nenhum formulário está liberado para o seu acesso. Isso
        acontece quando os módulos ainda não foram registrados ou quando o seu perfil só permite
        acompanhar. Fale com o administrador da sua organização ou com o consultor responsável.
      </Aviso>
    </Cartao>
  );
}
